import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: Roboto;
  min-width: 150px;
`;

const Title = styled.p`
  font-size: 24px;
  font-weight: ${(props) => (props.weight ? props.weight : '500')};
  margin-bottom: 150px;
`;

export {
  Container,
  Title,
};
